import firebase from "firebase";
import "firebase/firestore";
import store from "./store";

var firebaseConfig = {
  apiKey: "AIzaSyDy1Gd3ulfHLzT5CX0TKXneDw86auxhCFM",
  authDomain: "exceptionjr-site.firebaseapp.com",
  databaseURL: "https://exceptionjr-site.firebaseio.com",
  projectId: "exceptionjr-site",
  storageBucket: "exceptionjr-site.appspot.com",
  messagingSenderId: "1010557454537",
  appId: "1:1010557454537:web:a82726cc3907eb75e46518",
  measurementId: "G-0C9RW2VQDS",
};

export const db = firebase.initializeApp(firebaseConfig).firestore();

// firebase.auth().onAuthStateChanged((user) => {
//   store.dispatch("fetchUser", user);
// });

const { Timestamp, GeoPoint } = firebase.firestore;
export { Timestamp, GeoPoint };

// db.settings({ timestampsInSnapshots: true });
